import { User } from '../loginUser'
export const UPDATE_LOGIN_USER = 'UPDATE_LOGIN_USER'

export interface UpdateLoginUserAction {
  type: typeof UPDATE_LOGIN_USER
  user: User | null
}

export const updateUserInStore = (user: User | null): UpdateLoginUserAction => {
  return {
    type: UPDATE_LOGIN_USER,
    user: user,
  }
}
